import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { ArrowLeft } from '@untitledui/icons';
import { useBackLink } from '@/hooks/use-back-link';
import { cx } from '@/utils/cx';

export interface BackLinkProps {
    /** Fallback path when location.state.from is missing or invalid (e.g. external link, refresh) */
    fallbackTo: string;
    /** Content to render inside the link. Defaults to ArrowLeft icon. */
    children?: ReactNode;
    className?: string;
    /** Accessible label (e.g. from i18n). */
    'aria-label'?: string;
}

/**
 * Context-aware "Torna indietro" link. Uses React Router state.from when present
 * and valid; otherwise navigates to fallbackTo.
 */
export function BackLink({ fallbackTo, children, className, 'aria-label': ariaLabel }: BackLinkProps) {
    const { backPath } = useBackLink(fallbackTo);
    return (
        <Link
            to={backPath}
            className={cx('text-tertiary hover:text-primary', className)}
            aria-label={ariaLabel}
        >
            {children ?? <ArrowLeft className="size-5" />}
        </Link>
    );
}
